import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const branchShiftTypeLocaleModule: LocaleModule = {
  name: "branchShiftType",
  messages: { en: en, it: it },
};
